export const uk = {
    cancel: 'Отмена',
    create: 'Создать',
    'new-creative': 'Новый креатив'
};
